import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { ProcessSteps } from '../components/ProcessSteps';
import { CapabilitiesVideo } from '../components/CapabilitiesVideo';
import { Expertise } from '../components/Expertise';
import { Materials } from '../components/Materials';
import { Partnership } from '../components/Partnership';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-385">
      <Header data-id="element-386" />
      <main data-id="element-387">
        <Hero data-id="element-388" />
        <ProcessSteps data-id="element-389" />
        <CapabilitiesVideo data-id="element-390" />
        <Expertise data-id="element-391" />
        <Materials data-id="element-392" />
        <Partnership data-id="element-393" />
        <Contact data-id="element-394" />
      </main>
      <Footer data-id="element-395" />
    </div>;
}